import "../../src/assets/styles/Header.css";
import img_logo from "../imgs/logo.png";
import iconBack from "../icons/icon-back.png";
import imgTitleSupCskh from "../imgs/title-sup-cskh.png";
import imgTitleFullName from "../imgs/title-full-name.png";
import imgTitlePhone from "../imgs/title-phone.png";
import imgTitleEmail from "../imgs/title-email.png";
import imgTitleBank from "../imgs/title-bank.png";
import { useNavigate } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";

function Header({ isPageSearch, pageToAcction, data, currentPage }) {
  const navigate = useNavigate();
  const backToSearch = () => {
    if (pageToAcction) navigate(pageToAcction, { state: data });
    else navigate("/");
  };

  return (
    <div>
      <div className="status-bar"></div>
      <div className="header">
        <div className="header-logo">
          {!isPageSearch && (
            <img
              className="img-icon-back"
              style={{ cursor: "pointer" }}
              src={iconBack}
              alt="icon-back"
              id="btn-back"
              onClick={backToSearch}
            />
          )}
          <div className="main-logo">
            <img src={img_logo} alt="logo"></img>
            <HomeIcon
              sx={{
                position: "absolute",
                backgroundColor: "white",
                borderRadius: "50%",
                padding: 1,
                top: 5,
                right: 10,
                fontSize: 30,
                fill: "#34a749",
                cursor: "pointer",
              }}
              onClick={() => (window.location.href = "https://ok9.com/")}
            />
          </div>
        </div>
        {
          {
            full_name: (
              <div className="main-title main-title-name">
                <img src={imgTitleFullName} alt="logo"></img>
              </div>
            ),
            phone_number: (
              <div className="main-title main-title-phone">
                <img src={imgTitlePhone} alt="logo"></img>
              </div>
            ),
            email: (
              <div className="main-title main-title-email">
                <img src={imgTitleEmail} alt="logo"></img>
              </div>
            ),
            bank: (
              <div className="main-title main-title-bank">
                <img src={imgTitleBank} alt="logo"></img>
              </div>
            ),
          }[currentPage]
        }
        {!currentPage && (
          <div className="main-title main-title-cskh">
            <img src={imgTitleSupCskh} alt="title"></img>
          </div>
        )}
        {/* <p>HỖ TRỢ KHÁCH HÀNG</p> */}
      </div>
    </div>
  );
}

export default Header;
